<template>
  <div class="home">
    <router-link to="/plusarticle/1401877913885440">有评论</router-link>
    <router-link to="/plusarticle/1400227803372288">无评论</router-link>
    <!-- <router-link to="/plusarticle/1379772909330432">123</router-link> -->
  </div>
</template>

<script>
export default {
  name: "HomeView",
};
</script>
